import { useState } from "react"
import { Grower, GrowersList } from "../../interfaces/interfaces.auth"
import { IoAddCircle, IoChevronDown, IoChevronUp } from "react-icons/io5";
import { LuSprout, LuSquarePen, LuTrash2 } from "react-icons/lu";

import PopUpButton from "../modals/PopUpButton";
import { ModalAddContact } from "../modals/ModalAddContact";
import { ModalConfirmation } from "../ui/ModalConfirmation";
import { useRemoveSupplier } from "../../api/useSupplier";
import { useDispatch } from "react-redux";
import { startChecking } from "../../store/asyncMethods/authMethods";
import { ModalEditSupplier } from "../modals/ModalEditSupplier";
import { Contact } from "../profile/Contact";
import { useRemoveGrower } from "../../api/useGrower";
import { ModalAddField } from "../modals/ModalAddField";
import { Field } from "../profile/Field";
import { ModalAddGrower } from "../modals/ModalAddGrower";


interface Props {
    grower: Grower
    target: GrowersList
}

export const CardGrower = ({ grower, target }: Props) => {

    const dispatch = useDispatch()
    const [activeAccordeon, setActiveAccordeon] = useState<boolean>(false)
    const [modalField, setModalField] = useState<boolean>(false)
    const [modalEditGrower, setModalEditGrower] = useState<boolean>(false)
    const [confirmation, setConfirmation] = useState<boolean>(false)
    const { mutate, isLoading } = useRemoveGrower()

    const PopSupplierBtn = () => {
        return (
            <PopUpButton>
                <p className='font-normal text-no-wrap py-05 flex flex-gap mr-05' onClick={() => setModalEditGrower(true)}><LuSquarePen /> Edit Grower</p>
                <p className='font-normal text-no-wrap py-05 flex flex-gap mr-05' onClick={() => setModalField(true)}><LuSprout /> Add Field</p>
                <p className='font-normal text-no-wrap py-05 flex flex-gap text-red mr-05' onClick={() => setConfirmation(true)}><LuTrash2 />Remove Grower</p>
            </PopUpButton>
        )
    };

    const removeGrower = () => {
        mutate({
            id: target.id,
            model: target.model,
            growerId: grower._id
        }, {
            onSuccess: async () => {
                dispatch(startChecking())
                setConfirmation(false)
            },
            onError: (error) => console.log(error)
        })
    };

    return (
        <div className="w-100 supplier-card mb-1">
            {
                modalField &&
                <ModalAddField
                    grower={grower}
                    closeModal={() => setModalField(false)}
                    target={target}
                />
            }

            {
                modalEditGrower &&
                <ModalAddGrower
                    closeModal={() => setModalEditGrower(false)}
                    target={target}
                    grower={grower}
                />
            }

            {
                confirmation &&
                <ModalConfirmation
                    action={removeGrower}
                    closeConfirmation={() => setConfirmation(false)}
                    msg="Are you sure you want to remove this grower?"
                    buttonName="Remove"
                    isLoading={isLoading}
                />
            }

            {/* <div className={`supplier-main ${activeAccordeon ? "border-b" : ""}`}> */}
            <div className={`tw-grid tw-grid-cols-[1fr_2fr] tw-px-4 tw-py-2 tw-items-center ${activeAccordeon ? "border-b" : ""}`}>
                <p className="bold font-normal">{grower.ggn_number}</p>
                <div className="flex">
                    <p className="font-normal flex-1">{grower.name}</p>
                    <div className="flex">
                        <PopSupplierBtn />
                        <button
                            className="ml-1 flex"
                            onClick={() => setActiveAccordeon(!activeAccordeon)}
                        >
                            {activeAccordeon ? <IoChevronUp /> : <IoChevronDown />}
                        </button>
                    </div>
                </div>
            </div>

            <div className={`supplier-wrapper ${activeAccordeon && 'active'}`}>
                {
                    grower.fields.length > 0
                        ?
                        grower.fields.map((field, idx) => (
                            <Field
                                key={field.name + idx}
                                field={field}
                                grower={grower}
                                target={target}
                            />
                        ))
                        :
                        <div className="flex-center my-1">
                            <p className="text-center font-small bold">No fields</p>
                            <button
                                className="flex-center ml-02 color-blue"
                                onClick={() => setModalField(true)}>
                                <IoAddCircle size={20} />
                            </button>
                        </div>
                }
            </div>
        </div>
    )
}
